import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommunicationConfigService } from '@argalis-apps/angular-global';

@Injectable({
  providedIn: 'root'
})
export class FactureService {
  constructor(private communicationConfigService: CommunicationConfigService, private http: HttpClient) {}

  getListByIdClient(idclient: string | number) {
    // let params = new HttpParams();
    // params = params.append('idclient', idclient.toString());
    // params = params.append('extranet', true.toString()); // false.toString() pour les tests
    return this.http.get<any[]>(`${this.communicationConfigService.getApiUri()}/facture/facture-list`, {
      params: { idclient: idclient.toString(), extranet: 'true' }
    }); // TODO: remettre false a true
  }
}
